import { ReactNode } from 'react';

interface ProviderInfoRowProps {
  icon: ReactNode;
  label: string;
  /**
   * Rendered only when truthy. Callers are expected to skip rendering the row
   * entirely when there is no backing data — this component never invents a
   * placeholder value.
   */
  value?: ReactNode;
}

/**
 * A single label/value row with a pale-cyan rounded icon chip.
 * Used by the Provider Information and Contact Information cards.
 */
const ProviderInfoRow = ({ icon, label, value }: ProviderInfoRowProps) => (
  <div className="flex items-start gap-3 py-3">
    <span
      aria-hidden="true"
      className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-brandpalecyan/30 text-brandOcean"
    >
      {icon}
    </span>
    <div className="min-w-0 flex-1">
      <p className="text-[11px] font-medium uppercase tracking-wide text-gray-500">
        {label}
      </p>
      <div className="mt-0.5 break-words text-sm font-semibold text-brandnavy">
        {value}
      </div>
    </div>
  </div>
);

export default ProviderInfoRow;
